import { createI18n } from 'vue-i18n';
import zh from './zh';
import en from './en';

const messages = {
  zh,
  en
};

const i18n = createI18n({
  legacy: false, // 使用Composition API模式
  locale: localStorage.getItem('language') || 'zh', // 默认语言
  fallbackLocale: 'en', // 回退语言
  messages,
});

// 添加到全局属性以便在任何地方访问
(window as any).i18nInstance = i18n;

export default i18n;